var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "page-header-wrapper padding-rb" },
      [_c("PageHeader", { attrs: { title: `Dashboard` } })],
      1
    ),
    _c("div", { ref: "tableWrapper", staticClass: "table-wrapper" }, [
      _c("iframe", {
        ref: "myIframe",
        attrs: {
          title: "EMSL",
          src: _vm.powerbiUrl,
          frameborder: "0",
          allowFullScreen: "true",
        },
        on: { load: _vm.handleIframeLoad },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }